import { Col, Container, Row } from "react-bootstrap";

function Footer({ className }) {
	const heading = "text-white text-uppercase small fw-semibold";
	const menuLink =
		"text-white small text-decoration-none link-underline-opacity-0 link-underline-opacity-50-hover";
	const subtleLink =
		"text-white-50 text-decoration-none link-underline-opacity-0 link-underline-opacity-50-hover";

	return (
		<footer className={`bg-dark-blue ${className || ""}`} style={{marginTop: "64px"}}>
			{/* Real top padding is required: the first Row's gy-5 sets a negative
			    margin-top that used to escape the footer via margin collapse in
			    the old block layouts. Inside a flex layout margins don't
			    collapse, so without padding the content hugs the footer's top
			    edge. (pt-6 was a no-op — that class never existed in our CSS.) */}
			<Container className="pt-5 pb-5">
				{/* Top Grid */}
				{/* gx-4 on phones: gx-5's -24px row margins overflow the 12px
				    container padding and cause page-wide horizontal scroll. */}
				<Row
					className="gy-5 gx-4 gx-lg-5 pb-5"
					style={{ borderBottom: "1px solid var(--orange)" }}
				>
					{/* Brand */}
					<Col lg={3} className="d-flex flex-column gap-3">
						<a
							href="/videos"
							className="navbar-brand-small text-decoration-none monument-font"
							style={{ letterSpacing: "1px", marginTop: "4px" }}
						>
							<span className="text-white">MYGOLF</span>
							<span className="text-secondary">DNA</span>
						</a>

						<p className="small text-white-50 mb-3">
							Smarter practice. Better golf.
						</p>

						{/* Ultra-minimal icon row */}
						<div className="d-flex gap-3 fs-5">
							<a
								href="https://www.instagram.com/mygolfdna/"
								className="text-white-50 hover-opacity"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Instagram"
							>
								<i className="bi bi-instagram" />
							</a>
							<a
								href="https://www.youtube.com/@MyGolfDNA"
								className="text-white-50 hover-opacity"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="YouTube"
							>
								<i className="bi bi-youtube" />
							</a>
							<a
								href="https://www.tiktok.com/@mygolfdna"
								className="text-white-50 hover-opacity"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="TikTok"
							>
								<i className="bi bi-tiktok" />
							</a>
						</div>
					</Col>

					{/* Membership */}
					<Col xs={6} lg={3}>
						<h6 className={heading}>Membership</h6>
						<ul className="list-unstyled d-grid gap-2 mt-3">
							<li>
								<a className={menuLink} href="/pricing">
									Become a Member
								</a>
							</li>
							<li>
								<a className={menuLink} href="/reviews">
									Swing Reviews
								</a>
							</li>
							<li>
								<a className={menuLink} href="/clinics/dual-force-golf-school">
									Clinics
								</a>
							</li>
							<li>
								<a
									className={menuLink}
									href="https://meetings.hubspot.com/chris3535/mygolfdna"
									target="_blank"
									rel="noopener noreferrer"
								>
									PocketPRO
								</a>
							</li>
						</ul>
					</Col>

					{/* Videos */}
					<Col xs={6} lg={3}>
						<h6 className={heading}>Videos</h6>
						<ul className="list-unstyled d-grid gap-2 mt-3">
							<li>
								<a className={menuLink} href="/videos">
									All Videos
								</a>
							</li>
							<li>
								<a className={menuLink} href="/videos?category=4">
									Getting Started
								</a>
							</li>
							<li>
								<a className={menuLink} href="/videos?category=1">
									Tour Pro Analysis
								</a>
							</li>
							<li>
								<a className={menuLink} href="/videos?category=12">
									Testimonials
								</a>
							</li>
						</ul>
					</Col>

					{/* Resources (Articles + Shop) */}
					<Col xs={12} lg={3}>
						<h6 className={heading}>Resources</h6>
						<ul className="list-unstyled d-grid gap-2 mt-3">
							<li>
								<a
									className={menuLink}
									href="https://blog.mygolfdna.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Blog
								</a>
							</li>
							<li>
								<a
									className={menuLink}
									href="https://shop.mygolfdna.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Training Aids
								</a>
							</li>
						</ul>
					</Col>
				</Row>

				{/* Bottom Bar with dot-separated inline nav */}
				<Row className="pt-4">
					<Col className="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-3">
						<div className="text-white-50" style={{ fontSize: "0.8125rem" }}>
							© {new Date().getFullYear()} MyGolfDNA.com
						</div>
						<nav
							className="d-flex align-items-center gap-3 text-white-50"
							style={{ fontSize: "0.8125rem" }}
							aria-label="Legal and support"
						>
							<a className={subtleLink} href="/policies/privacy">
								Privacy
							</a>
							<span aria-hidden="true">·</span>
							<a className={subtleLink} href="/policies/terms">
								Terms
							</a>
							<span aria-hidden="true">·</span>
							<a className={subtleLink} href="/support">
								Support
							</a>
						</nav>
					</Col>
				</Row>
			</Container>
		</footer>
	);
}

export default Footer;
